<template>
    <div class="wrapper">
        <div class="tit">
            <h1>{{ editing ? 'Editar' : 'Nuevo' }} usuario</h1>
        </div>
        <div class="ctn_general">

            <div class="tabla_ctn subir_producto">
                <div class="tabla_filtros">
                    <div class="tfiltros_col">
                        <p>Datos del usuario</p>
                    </div>
                </div>
                <div class="datos_producto_ctn">
                    <form class="formulario_x2" @submit.prevent="onProcess">
                        <c-input type="text" :field="$v.email" id="username"
                                 classes="grupo_campos tipo_text x2" label="Correo electrónico *"
                                 length="50"/>
                        <c-input type="password" :field="$v.password" id="password" length="50"
                                 classes="grupo_campos tipo_text x2" :label="'Contraseña' + (editing ? '':' *')"/>
                        <c-input type="text" :field="$v.name" id="firstName"
                                 classes="grupo_campos tipo_text x2" label="Nombre *" length="50"/>
                        <div class="grupo_campos">
                        </div>
                        <div class="grupo_boton">
                            <router-link tag="button" class="btn btn2" :to="{name:'users'}">
                                {{ editing ? 'Volver' : 'Cancelar' }}
                            </router-link>
                            <button class="btn" type="submit">Guardar</button>
                        </div>
                    </form>
                </div>
            </div>


        </div>
    </div>
</template>
<script>

import CInput from '../common/CInput.vue'
import UserService from "../../services/UserService";
import alert from '../../util/alert'
import {email, required, requiredIf} from 'vuelidate/lib/validators'
import {loading} from '../../util/util'

export default {
    props: {
        userIdIn: {
            type: String,
            required: false
        }
    },
    components: {CInput},
    data() {
        return {
            editing: false,
            email: null,
            password: null,
            name: null,
        }
    },
    validations: {
        email: {required, email},
        password: {
            required: requiredIf((model) => {
                return !model.editing;
            })
        },
        name: {required},
    }, watch: {
        userIdIn: function () {
            if (this.userIdIn)
                this.load(this.userIdIn);
            else
                this.clear();

        }
    },
    methods: {
        async load(userId) {
            const self = this;
            try {
                const response = (await UserService.getUser(userId)).data.payload;
                self.email = response.email;
                self.name = response.name;
                self.editing = true;
            } catch (e) {
                alert.error("No se encontró usuario");
            }
        },
        async onProcess() {
            const self = this;
            self.$v.$touch();
            if (self.$v.$error) return;

            const data = {
                email: self.email,
                password: self.password,
                name: self.name
            };
            try {
                loading(true);
                if (!self.userIdIn) {
                    const response = (await UserService.add(data)).data.payload;
                    self.$router.push({name: 'user-editor', params: {userId: response._id}});
                } else
                    await UserService.update(self.userIdIn, data);

                self.editing = true;
                self.password = null;
                alert.success("Se guardó información de usuario correctamente");
            } catch (e) {
                console.error("Error al guardar usuario", e);
                alert.error(e.response.data.message);
            }finally {
                loading(false);
            }
        },
        clear() {
            this.email = null;
            this.name = null;
            this.password = null;
            this.editing = false;
        }

    },
    async mounted() {
        const self = this;
        if (self.userIdIn)
            self.load(self.userIdIn);
    }
}
</script>



// WEBPACK FOOTER //
// src/components/users/UserEditor.vue